(function () {
  document.querySelectorAll(".klar-video-wall").forEach(function (section) {
    var grid = section.querySelector(".klar-video-wall__grid");
    if (!grid) return;

    var items = Array.from(grid.querySelectorAll(".klar-video-wall__item"));
    var videos = items.map(function (item) {
      return item.querySelector("video");
    });
    var currentIndex = -1;

    function scrollToItem(item) {
      if (grid.scrollWidth > grid.clientWidth) {
        // Mobile: horizontal scroll container
        var itemLeft = item.offsetLeft - grid.offsetLeft;
        grid.scrollTo({ left: itemLeft, behavior: "smooth" });
      } else {
        item.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }

    function setPlaying(index, playing) {
      if (items[index]) items[index].classList.toggle("is-playing", playing);
    }

    function playAt(index) {
      if (currentIndex >= 0 && currentIndex !== index) {
        var prev = videos[currentIndex];
        if (prev) prev.pause();
        setPlaying(currentIndex, false);
      }

      currentIndex = index;
      var video = videos[currentIndex];
      if (!video) return;

      scrollToItem(items[currentIndex]);
      video.currentTime = 0;
      setPlaying(currentIndex, true);
      video.play().catch(function () {
        // Autoplay blocked by browser
        setPlaying(currentIndex, false);
      });
    }

    // Auto-advance when a video ends
    videos.forEach(function (video, i) {
      if (!video) return;
      video.addEventListener("ended", function () {
        setPlaying(i, false);
        var next = i + 1;
        if (next < items.length && videos[next]) {
          playAt(next);
        } else {
          currentIndex = -1;
        }
      });
    });

    // Click: play that video, or pause/resume if already active
    items.forEach(function (item, i) {
      item.addEventListener("click", function () {
        var video = videos[i];
        if (!video) return;
        if (currentIndex === i && !video.paused) {
          video.pause();
          setPlaying(i, false);
        } else {
          playAt(i);
        }
      });
    });

    // Autoplay first video when section scrolls into view
    if ("IntersectionObserver" in window && videos[0]) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting && currentIndex === -1) {
            playAt(0);
            observer.disconnect();
          }
        },
        { threshold: 0.5 },
      );
      observer.observe(section);
    }
  });
})();
